import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Typography, Checkbox, Button, Row, Col } from 'antd';

const { Paragraph, Title } = Typography;

const HydraDocument = ({ showApproveButton, handleAccept }) => {
  return (
    <div
      style={{
        textAlign: 'justify',
        textJustify: 'inter-word',
        overflowY: 'scroll',
        height: 400,
      }}
    >
      <Title level={5}>
        ΟΡΟΙ ΚΑΙ ΠΡΟΥΠΟΘΕΣΕΙΣ ΧΡΗΣΗΣ ΚΑΙ ΣΥΜΜΕΤΟΧΗΣ ΣΤΗΝ ΗΛΕΚΤΡΟΝΙΚΗ ΠΛΑΤΦΟΡΜΑ
        ΔΙΕΞΑΓΩΓΗΣ ΔΙΑΔΙΚΤΥΑΚΩΝ ΔΗΜΟΠΡΑΣΙΩΝ (Ε-SALVAGE)
      </Title>
      <Paragraph>
        Η Ύδρα Ασφαλιστική Εταιρεία Λτδ έχει νόμιμη άδεια διαχείρισης της
        πλατφόρμας διεξαγωγής πλειοδοτικών δημοπρασιών οχημάτων, ασύμφορων προς
        επιδιόρθωση (Ε-SALVAGE) που είτε ανήκουν σε αυτήν είτε ανήκουν σε τρίτα
        πρόσωπα (εντολείς) εμπλεκόμενα σε τροχαία ατυχήματα, μετά από
        συγκρούσεις με ασφαλισμένα σε αυτήν οχήματα.
      </Paragraph>
      <Paragraph>
        Οι παρόντες όροι και προϋποθέσεις αποτελούν Σύμβαση μεταξύ Εσάς (στο
        εξής «Χρήστης») και της Ύδρα Ασφαλιστική Εταιρεία Λτδ ( στο εξής
        «Εταιρία») και καθορίζει τη συμβατική σχέση μεταξύ του Χρήστη και της
        Εταιρίας και τη χρήση από μέρους σας της ηλεκτρονικής πλατφόρμας
        πλειστηριασμών της VDFM (E-SALVAGE), στο εξής «πλατφόρμα»
      </Paragraph>
      <Paragraph>
        Παρακαλούμε σημειώστε ότι δεσμεύεστε με οποιαδήποτε προσφορά υποβάλετε
        στην πλατφόρμα.
      </Paragraph>
      <Paragraph>Η παρούσα Σύμβαση, καθορίζει:</Paragraph>
      <Paragraph>
        1. τους Όρους και Προϋποθέσεις που ο Χρήστης αποκτά το δικαίωμα χρήσης
        των υπηρεσιών της Πλατφόρμας
      </Paragraph>
      <Paragraph>
        2. Τους όρους και προϋποθέσεις συμμετοχής του Χρήστη στην διαδικασία
        δημοπρασιών της πλατφόρμας
      </Paragraph>
      <Paragraph>
        3. Τους όρους και Προϋποθέσεις που ρυθμίζουν το κόστος συνδρομής και
        κατακύρωσης της προσφοράς στην πλατφόρμα
      </Paragraph>
      <Paragraph>
        4. Τους όρους και προϋποθέσεις που ρυθμίζουν την κατακύρωση της
        προσφοράς και παραλαβή του οχήματος
      </Paragraph>
      <Paragraph>
        5. Τους όρους και προϋποθέσεις που αφορούν την Προστασία Προσωπικών
        Δεδομένων.
      </Paragraph>
      <Paragraph>
        6. Άλλους όρους και προϋποθέσεις που αφορούν ολόκληρη την παρούσα
        σύμβαση
      </Paragraph>
      <Title level={5}>1. ΔΙΚΑΙΩΜΑ ΧΡΗΣΗΣ ΥΠΗΡΕΣΙΩΝ ΠΛΑΤΦΟΡΜΑΣ</Title>
      <Paragraph>
        1.1 Το δικαίωμα χρήσης των υπηρεσιών της Πλατφόρμας και η πρόσβαση στον
        τόπο δημοπρασιών της Εταιρείας, παρέχεται κατόπιν αποδοχής σχετικού
        αιτήματος από τον χρήστη και υπό την προϋπόθεση της πλήρους και
        ανεπιφύλακτης αποδοχής των κάτωθι περιγραφόμενων όρων. Για την αποδοχή
        της αίτησής του και την απόκτηση της ιδιότητας του Χρήστη. Ο Χρήστης
        δηλώνει υπεύθυνα, ότι:
      </Paragraph>
      <Paragraph>
        α) είναι φυσικό πρόσωπο ή νόμιμος εκπρόσωπος νομικού προσώπου, που
        ενασχολείται με την εμπορία ή την επισκευής αυτοκινήτων ή με τις
        αγοραποωλησίες αυτοκινήτων. και αγοραποωλησίες ανταλλακτικών
      </Paragraph>
      <Paragraph>
        β) τα προσωπικά στοιχεία που υπέβαλε ηλεκτρονικά στην αίτηση εγγραφής
        της Πλατφόρμας είναι αληθή.
      </Paragraph>
      <Paragraph>
        1.2 Προκειμένου να εγκριθεί η πρόσβαση του χρήστη στον τόπο δημοπρασιών
        της Πλατφόρμας, ο χρήστης οφείλει να αποστείλει ταχυδρομικώς ή μέσω
        email ή να παραδώσει αυτοπροσώπως τα κάτωθι έγγραφα προς την Εταιρεία:
      </Paragraph>
      <Paragraph>
        • Φωτοτυπία ταυτότητας ή πιστοποιητικού συστάσεως του αιτούντος
        επαγγελματία φυσικού προσώπου ή του νομίμου εκπροσώπου του αιτούντος
        νομικού προσώπου
      </Paragraph>
      <Paragraph>
        • Πρόσφατο τιμολόγιο της επιχείρησης (εντός διμήνου)
      </Paragraph>
      <Paragraph>
        • Γραπτή επιστολή που να περιέχει αίτηση του για λήψη κωδικών και
        συμμετοχή στην πλατφόρμα
      </Paragraph>
      <Paragraph>
        1.3 Η Εταιρεία έχει το δικαίωμα ανά πάσα στιγμή να ελέγχει την ακρίβεια
        των στοιχείων που παρέχονται από τον χρήστη κατά την εγγραφή του και να
        ζητάει συμπληρωματικά στοιχεία. Εάν η επαλήθευση αυτή οδηγήσει στον
        εντοπισμό ανακριβών στοιχείων διατηρεί το δικαίωμα να απορρίψει το
        αίτημα εγγραφής ή να αναστείλει ή να αποκλείσει μόνιμα την πρόσβαση και
        χρήση της πλατφόρμας.
      </Paragraph>
      <Paragraph>
        Εφόσον η αυθεντικότητα των εγγράφων πιστοποιηθεί και η Εταιρεία
        αποδεχθεί το αίτημα του Χρήστη η Εταιρεία παραδίδει στον Χρήστη κωδικούς
        πρόσβασης, τους οποίους ο Χρήστης ενεργοποιεί εντός 3 ημερών. Ακολούθως
        ο λογαριασμός του Χρήστη ο οποίος λαμβάνει ηλεκτρονική επιβεβαίωση της
        εγγραφής μαζί με τον προσωπικό κωδικό της επιλογής του, με τον οποίο θα
        μπορεί να συνδεθεί στην πλατφόρμα χρησιμοποιώντας όνομα χρήστη
        (username), το οποίο για την διασφάλιση αδιάβλητου της δημοπρασίας και
        αποφυγή συμπαιγνιών μεταξύ των Μελών δεν πρέπει να σχετίζεται με
        οποιοδήποτε τρόπο με την επωνυμία του νομικού προσώπου ή το
        ονοματεπώνυμο των φυσικών προσώπων. Η παράβαση της υποχρέωσης αυτής
        παρέχει στην Εταιρεία κατά τη κρίση της και χωρίς προειδοποίηση το
        δικαίωμα να διαγράψει τον Χρήστη.
      </Paragraph>
      <Paragraph>
        1.4 Κάθε Χρήστης έχει το δικαίωμα να έχει στην κατοχή του μόνο ένα (1)
        λογαριασμό. Ο Χρήστης είναι υπεύθυνος για την φύλαξη του προσωπικού του
        κωδικού πρόσβασης και του ονόματος χρήστη (username), ώστε να
        αποφεύγεται η παράνομη χρήση των υπηρεσιών από τρίτα μη εξουσιοδοτημένα
        πρόσωπα, συμπεριλαμβανομένων υπαλλήλων, συνεργατών του και μελών της
        οικογένειάς του. Σε περίπτωση απώλειας για οιοδήποτε λόγο των κωδικών
        του Χρήστη ανωτέρω στοιχείων, ο Χρήστης υποχρεούται όπως επικοινωνήσει
        εντός είκοσι τεσσάρων (24) ωρών μέσω ηλεκτρονικού ταχυδρομείου με την
        Εταιρεία και δηλώσει την εν λόγω απώλεια. Το Μέλος ευθύνεται απεριόριστα
        για οποιαδήποτε αγορά που πραγματοποιείται με την χρήση του ονόματος
        χρήστη του, ακόμα και μετά την απώλεια του ονόματος χρήστη του και του
        κωδικού πρόσβασης, και για κάθε ζημία που προκλήθηκε λόγω της χρήσης της
        πλατφόρμας με το δικό του όνομά χρήστη από τρίτα μη εξουσιοδοτημένα
        πρόσωπα.
      </Paragraph>
      <Paragraph>
        Ο καταχωρημένος λογαριασμός στην πλατφόρμα και ο κωδικός πρόσβασης του
        Μέλους δεν μπορούν να μεταβιβαστούν ή να πωληθούν σε τρίτους. Σε
        περίπτωση παραβίασης του ως άνω όρου η Εταιρεία έχει το δικαίωμα να
        αποβάλει όποιους μεταβιβάζουν ή πωλούν τον καταχωρημένο λογαριασμό τους
        στην πλατφόρμα και να ασκήσει αγωγή για αποζημίωση εναντίον τους για
        οποιαδήποτε ζημιά υπέστη.
      </Paragraph>
      <Paragraph>
        1.5 Σε κάθε περίπτωση μεταβολής των στοιχείων του (όπως όνομα, νομική
        μορφή, έδρα, διεύθυνση, νόμιμη εκπροσώπηση, τυχόν κατάθεση αίτησης
        πτώχευσης κλπ.) το Μέλος υποχρεούται εντός δύο (2) ημερών να ενημερώσει
        για τις μεταβολές αυτές την Εταιρεία μέσω e-mail.
      </Paragraph>
      <Paragraph>
        Σε κάθε περίπτωση η εγγραφή ως Χρήστη ή / και η συμμετοχή των χρηστών σε
        δημοπρασίες εναπόκειται στην απόλυτη και διακριτική ευχέρεια της
        Εταιρείας.
      </Paragraph>
      <Paragraph>
        1.6 Ο Χρήστης δηλώνει ρητά και ανεπιφύλακτα ότι η διεύθυνση ηλεκτρονικού
        ταχυδρομείου (e-mail), καθώς και τα στοιχεία επικοινωνίας του, τα οποία
        παραχώρησε προς την Εταιρεία κατά την υποβολή της αίτησης του για
        εγγραφή ή καταχώρησε κατά την εγγραφή του, είναι ασφαλή και στον πλήρη,
        αποκλειστικό και αδιαφιλονίκητο έλεγχό του, και ως εκ τούτου η Εταιρεία
        δεν ευθύνεται για οποιαδήποτε ζημία - τυχόν υποστεί το Μέλος από την
        πρόσβαση τρίτων, με οποιονδήποτε τρόπο στο ηλεκτρονικό του ταχυδρομείο.
      </Paragraph>
      <Title level={5}>ΔΙΑΔΙΚΑΣΙΕΣ ΔΗΜΟΠΡΑΣΙΩΝ E-SALVAGE </Title>
      <Title level={5}>2. ΧΡΕΩΣΗ ΥΠΗΡΕΣΙΩΝ</Title>
      <Paragraph>
        2.1.ΕΤΗΣΙΑ ΣΥΝΔΡΟΜΗ Ενόσω δεν υπάρχει αντίθετη ειδοποίηση ή ενημέρωση
        από Εταιρεία, δεν θα υπάρχει κόστος ετήσιας συνδρομής στην πλατφόρμα. H
        Εταιρεία επιφυλάσσει το δικαίωμα της για να επιβάλει χρέωση ετήσιας
        συνδρομής κατά την απόλυτη κρίση της, με προηγούμενη γραπτή ειδοποίηση
        προς τον Χρήστη, ενόσω διαρκεί η εγγραφή του ή με γραπτή ενημέρωση κατά
        το στάδιο της ανανέωσης της συνδρομής του. 2.2.ΕΞΟΔΑ ΣΥΜΜΕΤΟΧΗΣ
        ΠΛΗΣΤΗΡΙΑΣΜΟΥ ΚΑΙ ΚΑΤΑΚΥΡΩΣΗΣ ΠΡΟΣΦΟΡΑΣ
      </Paragraph>
      <Paragraph>
        Ο Χρήστης της πλατφόρμας που θα συμμετέχει στον πλειστηριασμό και θα του
        κατακυρωθεί η προσφορά από την Εταιρεία υποχρεούται όπως:
      </Paragraph>
      <Paragraph>
        Α. Εντός 2 (δύο) ωρών (εφόσον η μέρα και ώρα είναι εργάσιμη) από την
        κατακύρωση της προσφοράς ή αμέσως μόλις ανοίξουν τα κεντρικά γραφεία της
        Εταιρείας από την ώρα της λήξης του πλειστηριασμού, πληρώσει προς την
        Εταιρεία το ποσό των €150 (εκατό πενήντα ευρώ) για διαχειριστικά έξοδα.
        Η κατακύρωση της προσφοράς γνωστοποιείται στον Χρήστη με γραπτό
        ενημερωτικό ηλεκτρονικό μήνυμα (email) από μέρους της Εταιρείας. Το ποσό
        των €150 δεν θα είναι επιστρεπτέο προς τον Χρήστη για κανένα λόγο και θα
        οφείλεται ως χρεωστικό υπόλοιπο προς την Εταιρεία σε περίπτωση μη
        πληρωμής του για οποιοδήποτε λόγο. Η πιο πάνω χρέωση δεν περιλαμβάνει
        ΦΠΑ.
      </Paragraph>
      <Paragraph>
        Β. Εντός δύο ημερών από την κατακύρωση της προσφοράς, ταυτόχρονα με την
        παράδοση των εγγράφων που αναφέρονται στην παράγραφο Γ, πιο κάτω, από
        μέρους της Εταιρείας, όπως πληρώσει στην Εταιρεία με μετρητά ή έμβασμα
        (έναντι τραπεζικής απόδειξης εμβάσματος) ή με viza το αντίτιμο της
        προσφοράς του οχήματος που του κατακυρώθηκε στα πλαίσια της συμμετοχής
        στον πλειστηριασμό της πλατφόρμας.
      </Paragraph>
      <Paragraph>
        Γ. Η Εταιρεία ταυτόχρονα με την πληρωμή του αντιτίμου της κατακυρωμένης
        προσφοράς θα παραδίδει στον Χρήστη τα πιο κάτω έγγραφα:
      </Paragraph>
      <Paragraph>
        i)To πρωτότυπο του πιστοποιητικού εγγραφής του οχήματος ii)Το Έντυπο
        Μεταβίβασης Ιδιοκτησίας Μηχανοκινήτου Οχήματος (Τ.Ο.Μ. 9Β),
        υπογεγραμμένο και με πιστοποίηση της υπογραφής iii) Βεβαίωση
        ακινητοποίησης του οχήματος iv) Tα κλειδιά του οχήματος v) Aπόδειξη
        Είσπραξης του αντιτίμου
      </Paragraph>
      <Paragraph>
        Δ. Ο Χρήστης υποχρεούται όπως παραλάβει ο ίδιος το όχημα από τον τόπο
        που θα τον ενημερώσει η Εταιρεία. Τα έξοδα παραλαβής και μεταφοράς του
        οχήματος θα βαρύνουν τον Χρήστη.
      </Paragraph>
      <Paragraph>
        Με την καταβολή του τιμήματος, ο κίνδυνος από οποιαδήποτε τυχαία βλάβη ή
        καταστροφή του οχήματος μετατίθεται στον Χρήστη.
      </Paragraph>
      <Paragraph>
        Με την υπογραφή ή έγγραφη αποδοχή των Παρόντων Όρων και Προϋποθέσεων
        αμφότερα τα μέρη της Σύμβασης θα γνωστοποιήσουν εγγράφως το ένα στο άλλο
        τα στοιχεία του τραπεζικού λογαριασμού τους. Τα τυχόν έξοδα των
        τραπεζικών συναλλαγών που πραγματοποιούνται βαρύνουν τον Χρήστη.
      </Paragraph>
      <Paragraph>
        2.5 Εάν οι ως άνω πληρωμές δεν πραγματοποιηθούν εμπρόθεσμα, η Εταιρεία
        έχει το απόλυτο δικαίωμα να προβεί είτε διαζευκτικά είτε σωρευτικά στα
        ακόλουθα:
      </Paragraph>
      <Paragraph>
        Α. Να υπαναχωρήσει από την κατακύρωση της προσφοράς και είτε να
        κατακυρώσει την προσφορά στον αμέσως προηγούμενο συμμετέχοντα που έχει
        την ακριβώς προηγούμενη ψηλότερη προσφορά είτε κατά την απόλυτη κρίση
        της να επαναλάβει την διαδικασία πλειστηριασμού για το εν λόγω όχημα,
        αποκλείοντας τον Χρήστη από την διαδικασία πλειστηριασμού.
      </Paragraph>
      <Paragraph>
        B. Nα απαιτήσει αποζημιώσεις από τον Χρήστη για οποιαδήποτε απώλεια ή
        ζημιά υπέστη λόγω της αθέτησης της υποχρέωσης του Χρήστη, όπως μεταξύ
        άλλων στην περίπτωση που δεν καταστεί δυνατό να πωλήσει ή να κατακυρώσει
        την προσφορά σε άλλο πρόσωπο ή συμμετέχοντα στο πλειστηριασμό σε τιμή
        που αντιστοιχεί στο 90% της προσφοράς που κατακυρώθηκε στον Χρήστη. Σε
        τέτοια περίπτωση ο Χρήστης θα οφείλει όπως πληρώσει προς την Εταιρεία το
        ποσό που αποτελεί την διαφορά μεταξύ της προσφοράς που του κατακυρώθηκε
        και της τιμής του οχήματος που εν τέλει η Εταιρεία πώλησε ή κατακύρωσε
        σε άλλο Χρήστη ή πρόσωπο το όχημα.
      </Paragraph>
      <Paragraph>
        Γ. Να διαγράψει τον Χρήστη και/ή να τερματίσει όλα τα δικαιώματα χρήσης
        της πλατφόρμας.
      </Paragraph>
      <Paragraph>
        Δ. Ο Χρήστης θα καθίσταται υπερήμερος χωρίς καμία προηγούμενη όχληση από
        την πλευρά της Εταιρείας και οφείλει νόμιμους τόκους υπερημερίας 8% για
        κάθε ημέρα καθυστέρησης μέχρι αποπληρωμής.
      </Paragraph>

      <Paragraph>
        2.6. Επιπρόσθετα ο Χρήστης θα ευθύνεται για κάθε ζημία της Εταιρείας
        λόγω της παράλειψης του για συμμόρφωση με την παρούσα Σύμβαση.
      </Paragraph>
      <Title level={5}>3. ΔΙΕΞΑΓΩΓΗ ΔΗΜΟΠΡΑΣΙΩΝ</Title>

      <Paragraph>
        3.1. Για τους σκοπούς του παρόντος άρθρου πλειοδότης είναι ο Χρήστης
        υπερ του οποίου κατακυρώνεται η προσφορά. Πλειστηριασμός ή δημοπρασία
        και τα παράγωγα τους έχουν την ίδια έννοια και σημασία.
      </Paragraph>
      <Paragraph>
        3.2 Οι υπηρεσίες της Πλατφόρμας διατίθενται στο Μέλος μέσω της
        ιστοσελίδας «http://www.vdfm.gr» στην οποία πλειστηριάζονται και/ή
        δημοπρατούνται οχήματα ασύμφορα προς επιδιόρθωση ή μεταχειρισμένα
        οχήματα. Η δημοσίευση ή ανάρτηση στην πλατφόρμα των πινάκων των
        δημοπρατουμένων οχημάτων συνιστά πρόσκληση κατάθεσης προσφορών από την
        Εταιρεία προς τους Χρήστες. Η Εταιρεία ανακοινώνει τις ημερομηνίες
        διεξαγωγής on-line δημοπρασιών και τους πίνακες των δημοπρατουμένων
        οχημάτων της ηλεκτρονικής πλατφόρμας, στους οποίους περιλαμβάνονται ο
        τύπος και το έτος πρώτης άδειας κυκλοφορίας του οχήματος, τα χιλιόμετρα
        του οχήματος, και, κατ’ ελάχιστο, φωτογραφίες του οχήματος και των
        εμφανών φθορών του, ενώ προαιρετικά δύναται να περιλαμβάνονται τα
        τεχνικά χαρακτηριστικά και ο τυχόν πρόσθετος εξοπλισμός του οχήματος και
        περιγραφή της πραγματικής κατάστασης του οχήματος, όπως αποτυπώνεται
        εξωτερικά και εσωτερικά, με αναφορά των εμφανών φθορών.
      </Paragraph>
      <Paragraph>
        3.3 Με τη δημοσίευση το όχημα δημοπρατείται αυτόματα για 72 ώρες, πλην
        ωρών 00.00 Σαββάτου και 24.00 Κυριακής.
      </Paragraph>
      <Paragraph>
        3.4.Η δημοπρασία, κατ’ απόλυτη κρίση του εντολέα ή της εταιρίας, δύναται
        να είναι «κλειστή» ( ο Χρήστης δεν έχει τη δυνατότητα να βλέπει τις
        προσφορές άλλων Μελών) ή ανοικτή (ο Χρήστης έχει τη δυνατότητα να βλέπει
        την εκάστοτε υψηλότερη προσφορά). Μετά την πάροδο του ως άνω χρονικού
        διαστήματος τερματίζεται η δημοπράτηση του οχήματος, ανεξαρτήτως της
        ύπαρξης προσφορών.
      </Paragraph>
      <Paragraph>
        3.5.Διαφωνία ως προς το πρόσωπο του πλειοδότη επιλύεται κατά την απόλυτη
        κρίση και διακριτική ευχέρεια της Εταιρείας. Σε περίπτωση ισοϋψών
        προσφορών πλειοδοτούσα θεωρείται η χρονικά προγενέστερη προσφορά.
      </Paragraph>
      <Paragraph>
        3.6 Η Εταιρεία δικαιούται να διακόψει ή να ακυρώσει την δημοπρασία σε
        περίπτωση που διαπιστώσει οποιοδήποτε πρόβλημα ή δυσλειτουργία κατά τη
        διάρκεια της. Σε αυτή την περίπτωση, όλες οι προσφορές που έχουν
        υποβάλει οι Χρήστες στις ενεργείς δημοπρασίες που διακόπτονται,
        ακυρώνονται αυτόματα.
      </Paragraph>
      <Paragraph>
        3.7 Η Εταιρεία δεν φέρει ευθύνη σε περίπτωση που ο Χρήστης εμποδίστηκε
        να συμμετάσχει σε δημοπρασία λόγω τεχνικού προβλήματος. Η Εταιρεία
        ουδεμία ευθύνη φέρει για το περιεχόμενο και τη λειτουργία άλλων
        ιστοσελίδων, με τις οποίες συνδέεται η δική του μέσω links. Η Εταιρεία
        ευθύνεται μόνον για προβλήματα και δυσλειτουργίες που αποδίδονται σε
        πρόθεση ή βαριά αμέλεια εκπροσώπων ή υπαλλήλων της.
      </Paragraph>
      <Paragraph>
        3.8 Ο Χρήστης που επιθυμεί να αγοράσει ένα όχημα δύναται να υποβάλει μία
        (1) προσφορά αγοράς. Η υποβολή της προσφοράς από τον Χρήστη κατά τη
        διάρκεια μιας δημοπρασίας είναι μια νομικά δεσμευτική και μη ανακλητή
        πρόταση για κατάρτιση σύμβασης, ισχύουσα για χρονικό διάστημα δεκαπέντε
        (15) εργασίμων ημερών από τον τερματισμό της δημοπρασίας. Μετά το πέρας
        του ως άνω διαστήματος, εφόσον το όχημα δεν κατακυρωθεί από την
        Εταιρεία, ο Χρήστης δεν υποχρεούται να αγοράσει το όχημα, παρά μόνον
        οικειοθελώς.
      </Paragraph>
      <Paragraph>
        3.9. Η δημοπρασία δεν ολοκληρώνεται πριν εγκριθεί το αποτέλεσμά της από
        τον εντολέα (εάν το όχημα δεν ανήκει στην Εταιρεία), ο οποίος έχει
        περιθώριο δεκαπέντε (15) εργασίμων ημερών από τον τερματισμό της
        δημοπρασίας να δεχθεί ή να απορρίψει την υψηλότερη προσφορά. Ο Χρήστης
        ενημερώνεται ηλεκτρονικά για την κατακύρωση (αποδοχή) της προσφοράς του
        από την Εταιρεία, η οποία του χορηγεί τα στοιχεία επικοινωνίας με τον
        εντολέα (ιδιοκτήτη του οχήματος). Συγχρόνως, η Εταιρεία αποστέλλει στον
        ιδιοκτήτη του οχήματος ενημερωτικό sms με το ονοματεπώνυμο του Χρήστη
        και τον τηλεφωνικό αριθμό του. H Εταιρεία δεν θα έχει ευθύνη σε
        περίπτωση που για οποιοδήποτε λόγο δεν ολοκληρωθεί η αγορά του οχήματος
        μεταξύ του εντολέα (ιδιοκτήτης του οχήματος) και του πλειοδότη.
      </Paragraph>
      <Paragraph>
        3.10..7 Η Εταιρεία δεν αποδέχεται τον έλεγχο ή την ευθύνη για διαφορές
        ελλείψεις, μεταξύ της περιγραφής του οχήματος ή της κατάστασης του
        οχήματος που αποτυπώνεται στις φωτογραφίες που αναρτήθηκαν στον πίνακα
        δημοπρατουμένων ή για την ποιότητα και την ασφάλεια του οχήματος που
        έχει πλειστηριαστεί και για το οποίο υποβλήθηκε προσφορά που
        κατακυρώθηκε. Ο Χρήστης δύναται πριν από την ημερομηνία ανακοίνωσης του
        πλειστηριασμού και πριν από την λήξη του να επικοινωνήσει με την
        Εταιρεία ώστε να του υποδείξει τον χώρο φύλαξης του οχήματος που
        βρίσκεται το όχημα ώστε να το δει και ελέγξει.
      </Paragraph>

      <Title level={5}>4. ΔΙΑΡΚΕΙΑ ΣΥΜΒΑΣΗΣ – ΤΕΡΜΑΤΙΣΜΟΣ ΣΥΜΒΑΣΗΣ</Title>
      <Paragraph>
        4.1 Με την εγγραφή, ο Χρήστης δικαιούται να κάνει χρήση των υπηρεσιών
        της Πλατφόρμας για ένα (1) χρόνο.
      </Paragraph>
      <Paragraph>
        4.2 Η παρούσα σύμβαση θα ανανεώνεται αυτομάτως για ένα (1) έτος με τους
        ίδιους όρους και συμφωνίες, εφόσον δεν τερματιστεί εγγράφως από κάποιο
        από τα συμβαλλόμενα μέρη το αργότερο τρεις μήνες πριν από την πάροδο
        εκάστου έτους ανανέωσης.
      </Paragraph>
      <Paragraph>
        4.3 Ο Χρήστης δικαιούται να υπαναχωρήσει από την παρούσα Σύμβαση με
        γραπτή ειδοποίηση προς την Εταιρεία εντός δεκατεσσάρων (14) ημερών από
        την ηλεκτρονική αποδοχή της.
      </Paragraph>
      <Paragraph>
        4.4 Η Εταιρεία δικαιούται κατά τη κρίση της και χωρίς προειδοποίηση να
        τερματίσει την ιδιότητα του Χρήστη ακυρώνοντας τον κωδικό πρόσβασης και
        την ονοματοδοσία του χρήστη σε οποιαδήποτε περίπτωση παραβίασης των όρων
        της παρούσας σύμβασης ή εάν διαπιστώσει οποιαδήποτε ενέργεια που είναι
        ικανή να βλάψει τα συμφέροντα τρίτων ή της ίδιας.
      </Paragraph>
      <Paragraph>
        Ενδεικτικώς, δικαιούται να διαγράφει Χρήστες οι οποίοι:
      </Paragraph>

      <Paragraph>
        α) παρείχαν ανακριβή στοιχεία κατά την εγγραφή ή δεν ενημέρωσαν για την
        μεταβολή των στοιχείων τους
      </Paragraph>
      <Paragraph>
        β) καθυστερούν την εξόφληση του ποσού του salvage από προηγούμενες
        αγορές ή συμφωνίες προς αγορά
      </Paragraph>
      <Paragraph>
        γ) καθυστερούν επανειλημμένα την παραλαβή των οχημάτων που αγόρασαν
      </Paragraph>
      <Paragraph>
        δ) καθυστερούν να προβούν στη μεταβίβαση των οχημάτων που αγόρασαν
      </Paragraph>
      <Paragraph>
        ε) έχει κατατεθεί εναντίον τους αίτηση πτώχευσης ή διάλυσης ή
        εκκαθάρισης κ.λπ.
      </Paragraph>
      <Paragraph>
        στ) κάνουν κακή χρήση του κωδικού πρόσβασης και των υπηρεσιών της
        Πλατφόρμας
      </Paragraph>
      <Paragraph>
        ζ) η συμπεριφορά τους δημιουργεί υπόνοιες για χειραγώγηση της τιμής
        δημοπρατούμενου οχήματος
      </Paragraph>
      <Paragraph>
        η) παραβιάζουν τις κείμενες διατάξεις η δικαιώματα άλλων Μελών
      </Paragraph>
      <Paragraph>
        θ) αναπτύσσουν άμεσα ή έμμεσα ανταγωνιστικές ενέργειες προς τις
        υπηρεσίες της Πλατφόρμας. Η Εταιρεία συγχρόνως με την καταγγελία
        δικαιούται να αξιώσει την αποκατάσταση της ζημίας που υπέστη από την
        αντισυμβατική συμπεριφορά του Χρήστη.
      </Paragraph>

      <Title level={5}>5. ΑΠΑΛΛΑΓΗ ΕΥΘΥΝΗΣ</Title>

      <Paragraph>
        5.1 Ο Χρήστης δηλώνει ότι , ως επαγγελματίας, έχει πλήρη γνώση του τομέα
        των οχημάτων που είναι ασύμφορα προς επιδιόρθωση, γνωρίζει δε ότι οι
        εμπορικά συμφέρουσες δημοπρασίες της Πλατφόρμας δεν επιτρέπουν την
        λεπτομερή τεχνική επιθεώρηση των οχημάτων καθώς και ότι οι πληροφορίες
        που αφορούν τα δημοπρατούμενα οχήματα βασίζονται κυρίως σε πληροφορίες
        που ελήφθησαν από τον ιδιοκτήτη του οχήματος.
      </Paragraph>
      <Paragraph>
        5.2 Ρητώς συνομολογείται ότι οι περιγραφές, τα τεχνικά στοιχεία, οι
        εκτιμήσεις υλικής ζημιάς και λοιπές πληροφορίες των οχημάτων, που
        παρουσιάζονται στην Πλατφόρμα, πραγματοποιούνται με αποκλειστική
        επιμέλεια του εντολέα της δημοπρασίας (ιδιοκτήτη του οχήματος) και δεν
        αποτελούν συνομολογημένες ιδιότητες. Η Εταιρεία καταβάλει κάθε δυνατή
        προσπάθεια προκειμένου τα στοιχεία των δημοπρατουμένων οχημάτων στην
        Πλατφόρμα να είναι ενημερωμένα, όμως δεν πραγματοποιεί τεχνικούς ή
        μακροσκοπικούς ελέγχους στα οχήματα και κατά συνέπεια δεν παρέχει καμία
        εγγύηση για την ορθότητα των πληροφοριών που αφορούν τα οχήματα και την
        εν γένει κατάστασή τους, ούτε φέρει οιαδήποτε ευθύνη έναντι του
        πλειοδότη ή αγοραστή για απώλειες αγοραστή λόγω τυχόν εσφαλμένων
        πληροφοριών που αφορούν σε ένα όχημα που έχει τεθεί για τη δημοπρασία
        (λ.χ. χιλιομετρική απόσταση που έχει διανύσει το όχημα, τυχόν
        προηγούμενες ζημιές ή τεχνικές βλάβες, χρώμα, έτος κατασκευής,
        ημερομηνία πρώτης καταχώρησης κ.α.). Όταν δεν αναφέρονται τα χιλιόμετρα
        του οχήματος, θα θεωρείται ότι έχει διανύσει 999.999 χλμ. ενώ δεν
        ελέγχεται και δεν παρέχεται καμία εγγύηση για την κατάσταση λειτουργίας
        του κινητήρα του οχήματος. Ρητώς δε η Εταιρεία αποποιείται πάσης ευθύνης
        για τυχόν απώλειες που οφείλονται σε απάτη τρίτων (λ.χ. τροποποίηση
        χιλιομετρικής απόστασης που έχει διανύσει το όχημα, απάτη σχετική με τον
        αριθμό πλαισίου).
      </Paragraph>
      <Paragraph>
        5.3 Η εκτίμηση υλικής ζημιάς του οχήματος αποτελεί προσωπική εκτίμηση
        του εντολέα της δημοπρασίας του οχήματος και δεν υφίσταται καμία ευθύνη
        της Εταιρείας σε περίπτωση ανακρίβειας τους.
      </Paragraph>
      <Paragraph>
        5.4 Ρητώς συνομολογείται η Εταιρεία αποτελεί συμβαλλόμενο μέρος μόνο
        στον πλειστηριασμό του οχήματος. Όταν δεν είναι ιδιοκτήτρια του οχήματος
        που δημοπρατήθηκε δεν αποτελεί συμβαλλόμενο μέρος στην διαδικασία
        πώλησης των οχημάτων και δεν συμβάλλεται για την αγορά ή επισκευή τους,
        ενεργούσα με την ιδιότητα του μεσίτη πώλησης (Broker).
      </Paragraph>
      <Paragraph>
        5.5 Η Εταιρεία δεν ευθύνεται για την παράδοση του οχήματος.
      </Paragraph>
      <Paragraph>
        5.6 Η Εταιρεία δεν ευθύνεται σε καμία περίπτωση εάν ο Χρήστης αδυνατεί
        να ταξινομήσει ή να μεταβιβάσει το όχημα λόγω έλλειψης απαραίτητων
        εγγράφων, για τον έλεγχο και την απόκτηση των οποίων, αποκλειστικά
        υπεύθυνος είναι ο Χρήστης.
      </Paragraph>
      <Paragraph>
        5.7 Ρητώς συνομολογείται ότι τα δημοπρατούμενα οχήματα στην Πλατφόρμα
        δύναται να περιλαμβάνονται και σε άλλες πλατφόρμες δημοπρασίας, κατά την
        απόλυτη κρίση του εντολέα της δημοπρασίας ή του ιδιοκτήτη εκάστου
        οχήματος.
      </Paragraph>
      <Paragraph>
        5.8 Η κατακύρωση της προσφοράς καταρτίζεται με την αποστολή από την
        Εταιρεία του ηλεκτρονικού ταχυδρομείου προς τον Χρήστη που πλειοδότησε,
        του μηνύματος για την κατακύρωση ή αποδοχή της οριστικής προσφοράς του.
      </Paragraph>
      <Paragraph>
        5.9 Η υποβολή και η αποδοχή των προσφορών υπόκειται πάντοτε στους
        ισχύοντες κανονισμούς της δημοπρασίας. Απαγορεύεται η καθ’ οιονδήποτε
        τρόπο χειραγώγηση της τιμής οποιουδήποτε οχήματος και η παρεμπόδιση καθ’
        οιονδήποτε τρόπο, προσφορών που γίνονται από άλλους Χρήστες.
      </Paragraph>

      <Title level={5}>6. ΠΑΡΑΛΑΒΗ ΟΧΗΜΑΤΟΣ:</Title>

      <Paragraph>6.1. ΠΟΥ ΔΕΝ ΑΝΗΚΕΙ ΣΤΗΝ ΕΤΑΙΡΕΙΑ</Paragraph>
      <Paragraph>
        6.1.1 Ο Χρήστης, εντός 2 (δύο) ωρών (εφόσον η μέρα και ώρα είναι
        εργάσιμη) από την παραλαβή του ενημερωτικού email για την κατακύρωση της
        προσφοράς ή αμέσως μόλις ανοίξουν τα κεντρικά γραφεία της Εταιρείας από
        την ώρα της λήξης του πλειστηριασμού, πληρώσει προς την Εταιρεία το ποσό
        των €150 (εκατό πενήντα ευρώ) για διαχειριστικά έξοδα. Έπειτα ο χρήστης
        εντός τεσσάρων (4) εργασίμων ημερών από την παραλαβή ενημερωτικού e-mail
        της Εταιρείας για την αποδοχή (κατακύρωση) της οριστικής προσφοράς του,
        υποχρεούται να έρθει σε επαφή με τον ιδιοκτήτη του οχήματος προκειμένου
        να ελέγξει την ύπαρξη των απαιτούμενων εγγράφων για τη μεταβίβαση του
        οχήματος, ήτοι πρωτότυπο του πιστοποιητικού εγγραφής, έγγραφο
        μεταβίβασης, πιστοποιητικό ακινητοποίησης ή της άδειας κυκλοφορίας του
        οχήματος, του ισχύοντος δελτίου τεχνικού ελέγχου (εφόσον το όχημα
        υποχρεούται να διαθέτει), της πράξης εξόφλησης (εάν το όχημα είναι
        αντικείμενο ενοικιαγοράς ή ανήκει κατά το ήμισυ σε Τράπεζα), και να
        παραλάβει το όχημα. Εάν διαπιστωθούν ελλείψεις στα παραπάνω έγγραφα ή
        αντικείμενα, ο ιδιοκτήτης του οχήματος θα επιβαρύνεται με το σχετικό
        κόστος, Εφόσον δεν υπάρχουν ελλείψεις ή αυτές τακτοποιηθούν με ευθύνη
        του Χρήστη, ο Χρήστης υποχρεούται να προβεί στην εξόφληση του τιμήματος
        της κατακύρωσης της προσφοράς προς τον ιδιοκτήτη και των σχετικών εξόδων
        διαχείρισης (€150) προς την Εταιρεία, σύμφωνα με τα οριζόμενα στον όρο
        2.2. και να ενημερώσει ηλεκτρονικά την Εταιρεία για την καταβολή του
        τιμήματος προς τον ιδιοκτήτη. Με την καταβολή του τιμήματος, ο κίνδυνος
        από οποιαδήποτε τυχαία βλάβη ή καταστροφή του οχήματος μετατίθεται στο
        Χρήστη. Η παραλαβή θα πρέπει να έχει ολοκληρωθεί με δαπάνη του Μέλους
        εντός του ως άνω χρονικού διαστήματος των τεσσάρων (4) εργάσιμων ημερών,
        άλλως η Εταιρεία ή ο εντολέας (ιδιοκτήτης του οχήματος) διατηρεί το
        δικαίωμα να ζητήσει από τον Χρήστη έξοδα φύλαξης του οχήματος. Ο Χρήστης
        υποχρεούται να αποστείλει άμεσα στην Εταιρεία αντίγραφο της νέας άδειας
        κυκλοφορίας ή έγγραφο για τη διαγραφή του οχήματος. Σε περίπτωση
        εξαγωγής, ο Χρήστης υποχρεούται να υποβάλλει στην Εταιρεία πλήρη
        αντίγραφα των απαραιτήτων δικαιολογητικών και εγγράφων εξαγωγής.
      </Paragraph>
      <Paragraph>
        6.1.2.Σε περίπτωση αδικαιολόγητης άρνησης ή αδυναμίας του Χρήστη να
        προσέλθει για να παραλάβει το όχημα εντός της ως άνω προθεσμίας, η
        Εταιρεία έχει τα δικαιώματα που περιγράφονται στην παράγραφο 2.5.
        ανωτέρω.
      </Paragraph>
      <Paragraph>6.2. ΠΟΥ ΑΝΗΚΕΙ ΣΤΗΝ ΕΤΑΙΡΕΙΑ</Paragraph>
      <Paragraph></Paragraph>
      <Paragraph>
        6.2.1. Ο Χρήστης εντός 2 (δύο) ωρών (εφόσον η μέρα και ώρα είναι
        εργάσιμη) από την παραλαβή του ενημερωτικού email για την κατακύρωση της
        προσφοράς ή αμέσως μόλις ανοίξουν τα κεντρικά γραφεία της Εταιρείας από
        την ώρα της λήξης του πλειστηριασμού, πληρώσει προς την Εταιρεία το ποσό
        των €150 (εκατό πενήντα ευρώ) για διαχειριστικά έξοδα.
      </Paragraph>
      <Paragraph>
        6.2.2. Εντός δύο ημερών από την κατακύρωση της προσφοράς, ταυτόχρονα με
        την παράδοση των εγγράφων που αναφέρονται στην παράγραφο Γ, πιο κάτω,
        από μέρους της Εταιρείας, ο Χρήστης υποχρεούται όπως πληρώσει στην
        Εταιρεία με μετρητά ή έμβασμα (έναντι τραπεζικής απόδειξης εμβάσματος) ή
        με viza το αντίτιμο της προσφοράς του οχήματος που του κατακυρώθηκε στα
        πλαίσια της συμμετοχής στον πλειστηριασμό της πλατφόρμας.
      </Paragraph>
      <Paragraph>
        Γ. Η Εταιρεία ταυτόχρονα με την πληρωμή του αντιτίμου της κατακυρωμένης
        προσφοράς θα παραδίδει στον Χρήστη τα πιο κάτω έγγραφα και/η
        αντικείμενα:
      </Paragraph>
      <Paragraph>
        i)To πρωτότυπο του πιστοποιητικού εγγραφής του οχήματος
      </Paragraph>
      <Paragraph>
        ii)Το Έντυπο Μεταβίβασης Ιδιοκτησίας Μηχανοκινήτου Οχήματος (Τ.Ο.Μ. 9Β),
        υπογεγραμμένο και με πιστοποίηση της υπογραφής
      </Paragraph>
      <Paragraph>iii) Βεβαίωση ακινητοποίησης του οχήματος</Paragraph>
      <Paragraph>iv) Tα κλειδιά του οχήματος</Paragraph>
      <Paragraph>v) Aπόδειξη Είσπραξης του αντιτίμου</Paragraph>
      <Paragraph>
        Δ. Ο Χρήστης υποχρεούται όπως παραλάβει ο ίδιος το όχημα από τον τόπο
        που θα τον ενημερώσει η Εταιρεία. Τα έξοδα παραλαβής και μεταφοράς του
        οχήματος θα βαρύνουν τον Χρήστη.
      </Paragraph>
      <Paragraph>
        Με την καταβολή του τιμήματος, ο κίνδυνος από οποιαδήποτε τυχαία βλάβη ή
        καταστροφή του οχήματος μετατίθεται στον Χρήστη.
      </Paragraph>
      <Paragraph>
        Σε περίπτωση αδικαιολόγητης άρνησης ή αδυναμίας του Χρήστη να
        συμμορφωθεί με τα πιο πάνω, η Εταιρεία έχει τα δικαιώματα που
        περιγράφονται στην παράγραφο 2.5. ανωτέρω.
      </Paragraph>

      <Title level={5}>7. ΠΟΛΙΤΙΚΗ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ</Title>

      <Paragraph>
        7.1. Τα στοιχεία που έχουν παρασχεθεί από τον Χρήστη κατά την υποβολή
        της αίτησης του για χρήση της πλατφόρμας και συμμετοχή στις δημοπρασίες
        οχημάτων της πλατφόρμας, καθώς και τα προσωπικά δεδομένα που περιέχονται
        σε οποιοδήποτε πρόσθετο έγγραφο που έχει επισυναφθεί στην εν λόγω αίτηση
        ή έχει αποσταλεί στην Εταιρεία προς τον σκοπό εξέτασης της εν λόγω
        αίτησης, όπως μεταξύ άλλων όνομα, αριθμός ταυτότητας, επάγγελμα,
        διεύθυνση, τηλέφωνο, email θα τυγχάνουν επεξεργασίας από την Εταιρεία
        για τους πιο κάτω σκοπούς :
      </Paragraph>
      <Paragraph>Α.Για σκοπούς δημιουργίας κωδικού πρόσβασης,</Paragraph>
      <Paragraph>
        Β. Για σκοπούς συμμετοχή του Χρήστη στις δημοπρασίες οχημάτων της Ύδρα
        Ασφαλιστική Εταιρεία Λτδ,
      </Paragraph>
      <Paragraph>
        Γ. Για σκοπούς επικοινωνίας με τον Χρήστη στην περίπτωση που κατακυρωθεί
        οποιαδήποτε προσφορά του στα πλαίσια της συμμετοχής του στις Δημοπρασίες
        οχημάτων της Ύδρα Ασφαλιστική Εταιρεία Λτδ,
      </Paragraph>
      <Paragraph>
        Δ. Προς τον σκοπό εκτέλεσης των Όρων και Προϋποθέσεων που διέπουν την
        συμμετοχή του Χρήστη στις Δημοπρασίες της Ύδρα Ασφαλιστική Εταιρεία Λτδ,
      </Paragraph>
      <Paragraph>
        Ε. Για σκοπούς εννόμων συμφερόντων της Ύδρα Ασφαλιστικής, και ιδιαίτερα
        την θεμελίωση ή υπεράσπιση νομικών απαιτήσεων που απορρέουν από τους
        παρόντες Όρους και Προϋποθέσεις που διέπουν την συμμετοχή του Χρήστη
        στις Δημοπρασίες της Ύδρα Ασφαλιστική Εταιρεία Λτδ.
      </Paragraph>
      <Paragraph>
        7.1.2. Ως εκ τούτου οι πληροφορίες του Χρήστη, οι οποίες δεν αποτελούν
        ευαίσθητα προσωπικά δεδομένα τυγχάνουν επεξεργασίας σύμφωνα με τον
        Γενικό Κανονισμό για την Προστασία των Προσωπικών Δεδομένων (GDPR), ΕΕ
        2016/679 και συγκεκριμένα σύμφωνα με το Άρθρο 6(α), ήτοι, για τους
        σκοπούς που έχει συναινέσει ο Χρήστης, το Άρθρο 6(β), ήτοι, η
        επεξεργασία είναι απαραίτητη για την σύναψη και εκτέλεση σύμβασης με τον
        Χρήστη, το Άρθρο 6(γ), ήτοι, για σκοπούς συμμόρφωσης μας με τις έννομες
        μας υποχρεώσεις (όπως φορολογική νομοθεσία, ασφαλιστική νομοθεσία) και
        το Άρθρο 6(στ), ήτοι, για τους σκοπούς των έννομων συμφερόντων που
        επιδιώκει η Εταιρεία.
      </Paragraph>
      <Paragraph>
        7.1.3. Τα προσωπικά δεδομένα του υποψήφιου Χρήστη, που περιέχονται σε
        αιτήσεις εγγραφή και Χρήση της πλατφόρμας Δημοπρασιών που έχουν
        απορριφθεί από την Εταιρεία διατηρούνται για περίοδο ενός χρόνου και
        μετά καταστρέφονται ή διαγράφονται. Τα Προσωπικά Δεδομένα των Χρηστών
        που έχουν λάβει κωδικούς και χρησιμοποιούν την πλατφόρμα Δημοπρασιών της
        Ύδρα Ασφαλιστική Εταιρεία Λτδ διατηρούνται για όσο χρονικό διάστημα
        ισχύει η παρούσα Σύμβαση. Τα προσωπικά δεδομένα των Χρηστών που έχουν
        διαγραφεί ή λήξει ή τερματιστεί η παρούσα εγγραφή τους ή σύμβαση
        διατηρούνται για περίοδο έως και 7 χρόνια από την διαγραφή ή λήξη ή
        τερματισμό της παρούσας σύμβασης ή για όσο χρονικό από τη λήξη ή από τη
        διευθέτηση οποιασδήποτε διαφοράς ή απαίτησης που προκύπτει σε σχέση με
        τους παρόντες όρους και προϋποθέσεις.
      </Paragraph>
      <Paragraph>
        7.1.4 Η Εταιρεία λαμβάνει οργανωτικά και τεχνικά μέτρα σύμφωνα με τις
        προδιαγραφές του Γενικού Κανονισμού περί Προστασίας Δεδομένων (Αρ. 32
        του ΓΚΠΔ), ως προς τις πληροφορίες του Χρήστη που λαμβάνει είτε εντύπως
        είτε ηλεκτρονικά είτε στην πλατφόρμα, για να διασφαλίσει ότι θα
        διατηρούνται ασφαλείς και προστατευμένες από μη εξουσιοδοτημένη
        αποκάλυψη ή πρόσβαση, τροποποίηση, τυχαία απώλεια ή άλλη παραβίαση ή
        παράνομη επεξεργασία. Τα εν λόγω μέτρα αποσκοπούν, μεταξύ άλλων, στον
        περιορισμό της πρόσβασης σε προσωπικά δεδομένα, στη διασφάλιση της
        ασφαλούς αποθήκευσης, στον περιορισμό του κινδύνου εμφάνισης ιών και
        άλλων επιβλαβών περιστατικών, στη διατήρηση ασφαλών αντιγράφων ασφαλείας
        και στην αποτελεσματική καταστροφή περιττών δεδομένων. Η Εταιρεία
        διατηρεί Πολιτική Ασφαλείας η οποία μπορεί να είναι στην διάθεση του
        Χρήστη όποτε την ζητήσει.
      </Paragraph>
      <Paragraph>
        7.1.5. Περαιτέρω ενημέρωση του Χρήστη σε ότι αφορά για το ποιος έχει
        πρόσβαση στις πληροφορίες του (αποδέκτες), ποια είναι τα δικαιώματα του,
        διαβίβαση των πληροφοριών εκτός Ευρωπαϊκής Ένωσης, πληροφορίες για τον
        Υπεύθυνο Προστασίας Προσωπικών Δεδομένων και την Εταιρεία, ως επίσης και
        άλλες πληροφορίες που αφορούν την επεξεργασία και προστασία των
        προσωπικών του δεδομένων, περιέχονται στην Πολιτική Προστασίας
        Προσωπικών Δεδομένων που βρίσκεται στην Ιστοσελίδα της Εταιρείας και
        συγκεκριμένα στον σύνδεσμο
        https://www.hydrainsurance.com/index.php/el/privacy-policy
      </Paragraph>
      <Paragraph>8.Διαιρετότητα</Paragraph>
      <Paragraph>
        Σε περίπτωση που ένας ή περισσότεροι όροι ή ρήτρες που περιέχονται στην
        παρούσα Σύμβαση καταστούν άκυροι ή μη εφαρμοστέοι, καθ’ οιονδήποτε
        τρόπο, η εν λόγω ακυρότητα ή μη εφαρμοσιμότητα, δεν θα επηρεάζει τους
        υπόλοιπους όρους της Σύμβασης και ότι η παρούσα Συμφωνία θα ερμηνεύεται
        ωσάν ο όρος/οι και/ή ρήτρα/ες να μην περιέχονταν σε αυτή.
      </Paragraph>
      <Paragraph>9. Ρήτρα Μη Παραίτησης</Paragraph>
      <Paragraph>
        Σε περίπτωση που είτε η Εταιρεία είτε ο Χρήστης παραιτηθεί από δικαίωμα
        ή αξίωση του που απορρέει από αθέτηση οποιουδήποτε όρου που περιέχεται
        στην παρούσα Σύμβαση, η εν λόγω παραίτηση δεν θα επηρεάζει και δεν θα
        θεωρείται παραίτηση από οποιαδήποτε προηγούμενη ή επόμενη αθέτησης της
        του ίδιου ή άλλου όρου της παρούσας Σύμβασης.
      </Paragraph>
      <Paragraph>10. Επικεφαλίδες</Paragraph>
      <Paragraph>
        Οι επικεφαλίδες των όρων και προϋποθέσεων της παρούσας Σύμβασης
        περιλαμβάνονται για χάριν αναφοράς και δεν έχουν σκοπό να επηρεάσουν την
        σημασία ή έννοια οποιωνδήποτε τέτοιων όρων και προνοιών στην Σύμβαση.
      </Paragraph>
      <Paragraph>11. Τροποποίηση </Paragraph>
      <Paragraph>
        Ουδεμία τροποποίηση ή προσθήκη στην παρούσα Συμφωνία δεν θα ισχύει για
        οποιοδήποτε σκοπό, εκτός εάν είναι έγγραφη και υπογεγραμμένη και από τα
        δύο συμβαλλόμενα μέρη ή τους εξουσιοδοτημένους αντιπροσώπους τους. Η
        έγγραφη αυτή μορφή μπορεί να καλύπτεται με διαβίβαση μέσω
        τηλεομοιοτυπίας (fax) ή ηλεκτρονικού ταχυδρομείου (email).
      </Paragraph>
      <Paragraph>12. Εφαρμοστέο δίκαιο και Δικαιοδοσία</Paragraph>
      <Paragraph>
        Η παρούσα Σύμβαση διέπεται από τους Νόμους της Κυπριακής Δημοκρατίας και
        αρμόδια για την επίλυση οποιωνδήποτε διαφορών προκύψουν από την παρούσα
        Σύμβαση είναι τα Δικαστήρια της Κυπριακής Δημοκρατίας.
      </Paragraph>
      {showApproveButton ? (
        <Row justify="center">
          <Button key="submit" type="primary" onClick={handleAccept}>
            Αποδέχομαι
          </Button>
        </Row>
      ) : null}
    </div>
  );
};

export default HydraDocument;
